import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    payBreakdowns: [],
    totalPayBreakdown: null,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    filterDate: "",
    companyRemittance: [],
    totalCompanyRemittance: null,
    batchingGroups: [],
    totalBatchingGroup: null,
    statutoryDs: [],
    totalStatutoryDs: null,
    branches: [],
    departments: [],
    employeeGrades: [],
    employees: [],
    teams: [],
    extraAllowances: [],
    totalExtraAllowance: null,
    currentCompanyRemittance: [],
    currentStatutoryDeduction: [],
    allowanceName: [],
    currentPageForPayPackage: 1,
    perPageForPayPackage: 5,
    payPackages: [],
    totalPayPackages: null,
    currentPageForSalary: 1,
    perPageForSalary: 5,
    salarySchedule: [],
    totalSalarySchedule: null,
    formDataForSalarySchedule: null,
    currentPageForPaymentUploads: 1,
    perPageForPaymentUploads: 5,
    paymentUploads: [],
    totalPaymentUploads: null,
    paymentUploadDetails: [],
    totalPaymentUploadDetails: null,
    perPageForPaymentUploadDetails: 5,
    currentPageForPaymentUploadDetails: 1,
    approvedPayments: [],
    totalApprovedPayments: null,
    currentPageForApprovedPayments: 1,
    perPageForApprovedPayments: 5,
    approvedPaymentSchedules: [],
    totalApprovedPaymentSchedules: null,
    currentPageForApprovedPaymentSchedules: 1,
    perPageForApprovedPaymentSchedules: 5,
    currentPageForMandates: 1,
    perPageForMandates: 5,
    mandates: [],
    totalMandate: null,
    showUploadDialog: false,
    uploadedEmployeesForSalaryId: [],
    companyStatutorySettings: {
      nhf_enabled: false,
      nhis_enabled: false,
      nhis_rate: 5.0,
      nsitf_enabled: false,
      itf_enabled: false,
    },
  },
  actions,
  mutations,
};
